module.exports = __webpack_public_path__ + "img/bend-card.92cf41e2.svg";